import {useState} from 'react'

export const NewInputModuleLogin = ({
	placeholder,
	error,
	type,
	id,
	name,
	value,
	onChange,
	onBlur,
	onFocus
}) => {
	const [active, setActive] = useState(false)
	return (
		<div className={`NewInputModuleLogin ${error && 'error'}`}>
			<input
				placeholder={placeholder}
				type={type}
				id={id}
				name={name}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				onFocus={onFocus}
			/>
			{active === 'done' && (
				<svg
					width='12'
					className='ok-sign'
					height='12'
					viewBox='0 0 12 12'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M11.5666 4.35C11.6444 4.60555 11.7028 4.87222 11.742 5.15C11.7806 5.42777 11.8 5.71111 11.8 6C11.8 6.8 11.6473 7.55266 11.342 8.258C11.0362 8.96377 10.6222 9.57778 10.1 10.1C9.57773 10.6222 8.96395 11.036 8.25862 11.3413C7.55284 11.6471 6.79995 11.8 5.99995 11.8C5.19995 11.8 4.44728 11.6471 3.74195 11.3413C3.03617 11.036 2.42217 10.6222 1.89995 10.1C1.37773 9.57778 0.963729 8.96377 0.657951 8.258C0.352618 7.55266 0.199951 6.8 0.199951 6C0.199951 5.2 0.352618 4.44711 0.657951 3.74133C0.963729 3.036 1.37773 2.42222 1.89995 1.9C2.42217 1.37777 3.03617 0.963775 3.74195 0.657997C4.44728 0.352664 5.19995 0.199997 5.99995 0.199997C6.63328 0.199997 7.23062 0.291552 7.79195 0.474664C8.35284 0.658219 8.86662 0.916664 9.33328 1.25C9.38884 1.29444 9.42217 1.34711 9.43328 1.408C9.4444 1.46933 9.42217 1.52777 9.36662 1.58333C9.32217 1.63889 9.26395 1.66666 9.19195 1.66666C9.11951 1.66666 9.05551 1.64444 8.99995 1.6C8.57773 1.3 8.11395 1.06933 7.60862 0.907997C7.10284 0.747108 6.56662 0.666664 5.99995 0.666664C4.52217 0.666664 3.26395 1.186 2.22528 2.22466C1.18617 3.26377 0.666618 4.52222 0.666618 6C0.666618 7.47777 1.18617 8.73622 2.22528 9.77533C3.26395 10.814 4.52217 11.3333 5.99995 11.3333C7.47773 11.3333 8.73617 10.814 9.77528 9.77533C10.814 8.73622 11.3333 7.47777 11.3333 6C11.3333 5.73333 11.314 5.47222 11.2753 5.21666C11.2362 4.96111 11.1777 4.71111 11.1 4.46666C11.0888 4.43333 11.0888 4.39444 11.1 4.35C11.1111 4.30555 11.1277 4.27222 11.15 4.25C11.2277 4.16111 11.3084 4.12777 11.392 4.15C11.4751 4.17222 11.5333 4.23889 11.5666 4.35ZM4.68328 8.11666L2.94995 6.38333C2.90551 6.33889 2.88617 6.286 2.89195 6.22466C2.89728 6.16377 2.92217 6.11111 2.96662 6.06666C3.02217 6.01111 3.07773 5.98333 3.13328 5.98333C3.18884 5.98333 3.2444 6.01111 3.29995 6.06666L5.03328 7.8L11.3166 1.51666C11.3611 1.47222 11.414 1.45289 11.4753 1.45866C11.5362 1.464 11.5888 1.48889 11.6333 1.53333C11.6888 1.58889 11.7166 1.64444 11.7166 1.7C11.7166 1.75555 11.6888 1.81111 11.6333 1.86666L5.38328 8.11666C5.28328 8.21666 5.16662 8.26666 5.03328 8.26666C4.89995 8.26666 4.78328 8.21666 4.68328 8.11666Z'
						fill='#3676F5'
					/>
				</svg>
			)}
			{error && (
				<svg
					width='12'
					height='11'
					viewBox='0 0 12 11'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M1.03324 10.1333C0.844347 10.1333 0.699902 10.05 0.599902 9.88332C0.499902 9.71665 0.499902 9.54998 0.599902 9.38332L5.56657 0.81665C5.66657 0.649984 5.81101 0.56665 5.9999 0.56665C6.18879 0.56665 6.33324 0.649984 6.43324 0.81665L11.3999 9.38332C11.4999 9.54998 11.4999 9.71665 11.3999 9.88332C11.2999 10.05 11.1555 10.1333 10.9666 10.1333H1.03324ZM5.9999 3.99998C5.93324 3.99998 5.87768 4.02221 5.83324 4.06665C5.78879 4.11109 5.76657 4.16665 5.76657 4.23332V7.09998C5.76657 7.16665 5.78879 7.22221 5.83324 7.26665C5.87768 7.31109 5.93324 7.33332 5.9999 7.33332C6.06657 7.33332 6.12213 7.31109 6.16657 7.26665C6.21101 7.22221 6.23324 7.16665 6.23324 7.09998V4.23332C6.23324 4.16665 6.21101 4.11109 6.16657 4.06665C6.12213 4.02221 6.06657 3.99998 5.9999 3.99998ZM5.9999 8.66665C6.0999 8.66665 6.18057 8.63332 6.2419 8.56665C6.30279 8.49998 6.33324 8.42221 6.33324 8.33332C6.33324 8.23332 6.30279 8.15265 6.2419 8.09132C6.18057 8.03043 6.0999 7.99998 5.9999 7.99998C5.91101 7.99998 5.83324 8.03043 5.76657 8.09132C5.6999 8.15265 5.66657 8.23332 5.66657 8.33332C5.66657 8.42221 5.6999 8.49998 5.76657 8.56665C5.83324 8.63332 5.91101 8.66665 5.9999 8.66665ZM0.966569 9.66665H11.0332L5.9999 0.999984L0.966569 9.66665Z'
						fill='#FF5334'
					/>
				</svg>
			)}
		</div>
	)
}
